<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :is-valid="isFormValid"
    :title="title"
    min-body-height="55vh"
    dialog-width="60%"
    header-shadow
    :agree-text="agreeText"
    @agree="handleAction"
    no-paddings-x
    :loading="isActionLoading"
  >
    <template #body>
      <v-col cols="12">
        <v-form ref="reportForm" v-model="isFormValid">
          <template v-if="isLoaded">
            <v-row no-gutters class="border-bottom pb-4" align="center">
              <v-col cols="3" class="text-left pb-5 pl-7">
                <span> {{ $i18n.t('admin.customReports.reportName') }}: </span>
              </v-col>
              <v-col style="max-width: 275px !important; margin-left: 50px">
                <data-input
                  v-model="computedReport.name"
                  :data-type="{ name: 'text' }"
                  :rules="[v => !!v || $i18n.t('rules.required')]"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="pb-4" align="center">
              <v-col cols="3" class="text-left pb-5 pl-7">
                <span> {{ $i18n.t('admin.customReports.reportLayer') }}: </span>
              </v-col>
              <v-col style="max-width: 275px !important; margin-left: 50px">
                <data-input
                  :items="featuresLayers"
                  v-model="computedReport.layer"
                  item-text="name"
                  item-value="id"
                  :data-type="{ name: 'select' }"
                  :rules="[v => !!v || $i18n.t('rules.required')]"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="border-bottom pb-4" align="center">
              <v-col cols="3" class="text-left pb-5 pl-7">
                <span> {{ $i18n.t('admin.customReports.reportDescription') }}: </span>
              </v-col>
              <v-col style="max-width: 275px !important; margin-left: 50px">
                <data-input v-model="computedReport.description" :data-type="{ name: 'text' }" />
              </v-col>
            </v-row>
            <v-row no-gutters class="px-7">
              <v-col cols="12">
                <v-row no-gutters class="pb-2">
                  <v-col cols="auto">
                    <span>
                      {{ $i18n.t('admin.customReports.SQLQuery') }}
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col v-if="!isNew" cols="auto">
                    <base-button
                      translation-path="admin.customReports.validateQuery"
                      class="mr-0"
                      :disabled="!computedReport.sql_query"
                      :loading="isValidateLoading"
                      @click="validateQueryHandler"
                    ></base-button>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <data-input
                      v-model="computedReport.sql_query"
                      :data-type="{ name: 'textarea' }"
                      :rules="[v => !!v || $i18n.t('rules.required')]"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-form>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import DataInput from '@/components/DataInput';
import { get, call } from 'vuex-pathify';

export default {
  name: 'ZDMReportsTabCustomDialog',
  components: {
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
    DataInput,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    reportData: {
      type: Object,
    },
  },
  data: () => ({
    isActionLoading: false,
    isFormValid: false,
    isLoaded: true,
    isValidateLoading: false,
  }),
  computed: {
    layers: get('layers/layers'),
    featuresLayers() {
      return this.$_objectToArray(this.layers).filter(
        layer => layer.type === 'features_layer' && layer.layer_scope === 'zdm_data'
      );
    },
    agreeText() {
      return this.isNew ? 'dialog.agreeAdd' : 'dialog.agreeSave';
    },
    isNew() {
      return this.reportData ? false : true;
    },
    title() {
      return this.isNew
        ? this.$i18n.t('admin.customReports.addReport')
        : this.$i18n.t('admin.customReports.editReport');
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    computedReport() {
      if (this.isNew) {
        return {
          name: null,
          description: null,
          layer: null,
          sql_query: null,
        };
      } else {
        let copiedReport = JSON.parse(JSON.stringify(this.reportData));
        delete copiedReport.id;
        return copiedReport;
      }
    },
  },
  watch: {
    isVisible(nV) {
      if (nV) {
        if (this.isNew) this.$refs?.reportForm?.reset();
        this.$refs?.reportForm?.resetValidation();
      }
    },
  },
  methods: {
    addCustomReport: call('zdmCustomReports/addCustomReport'),
    editCustomReport: call('zdmCustomReports/editCustomReport'),
    validateQuery: call('zdmCustomReports/validateQuery'),
    async validateQueryHandler() {
      this.isValidateLoading = true;
      try {
        await this.validateQuery(this.reportData.id);
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('dialog.sqlQueryValid'),
        });
      } catch (error) {
        console.log('error', error);
      } finally {
        this.isValidateLoading = false;
      }
    },
    async handleAction() {
      this.isActionLoading = true;
      try {
        if (this.isNew) {
          await this.addCustomReport(this.computedReport);
        } else {
          await this.editCustomReport({
            id: this.reportData.id,
            data: this.computedReport,
          });
        }
        this.computedIsVisible = false;
      } finally {
        this.isActionLoading = false;
      }
    },
  },
};
</script>
